export const funnelFeatureDefaultValue = { flow: 'default_flow' };
